import api from './api';
import { GetAllExperimentsResponse } from '../interfaces/Experiments';

const experimentsUIEndpointUrl = '/experiments-ui';

export const getAllExperiments =
  async (): Promise<GetAllExperimentsResponse> => {
    const response = await api.get(`${experimentsUIEndpointUrl}/descriptions`);

    return response.data;
  };

export const getExperiment = async (name: string): Promise<any> => {
  const response = await api.get(`${experimentsUIEndpointUrl}/${name}`);

  return response.data;
};

export const getExperimentHistory = async (name: string): Promise<any> => {
  const response = await api.get(
    `${experimentsUIEndpointUrl}/changelog/${name}`,
  );

  return response.data;
};

export const getExperimentChange = async (
  name: string,
  date: string,
): Promise<any> => {
  const response = await api.get(`${experimentsUIEndpointUrl}/changes`, {
    params: { experiment_name: name, date },
  });

  return response.data;
};

export const updateExperiment = async (
  experiment: string,
  message: string,
): Promise<any> => {
  const response = await api.put(
    `${experimentsUIEndpointUrl}/update-experiment`,
    {
      experiment: JSON.parse(experiment).experiment,
      message,
    },
  );

  return response;
};
